import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { TemplateRef } from '@angular/core';

/* eslint-disable sonarjs/cognitive-complexity */
export interface PasswordConstraint {
  name: string;
  formKey: string;
}
export interface SelectionsObj {
  color?: string;
  name: string;
  value?: number;
  note?: string;
  series?: SelectionsObj[];
}
export interface EChartOptions {
  chartType: string;
  title: string;
  subTitle?: string;
  rightlink?: string;
  rightlinkurl?: string;
  mainPercentageNote?: string;
  ratingPercentageChange?: string | number;
  subPercentageChange?: string | number;
  subPercentage?: string | number;
  subPercentageNote?: string;
  product?: string;
  toolTipContent?: string;
  footNote?: string;
  footerImage?: string;
  domain: string[];
  isGradient?: boolean;
  canShowLegend?: boolean;
  canShowLabels?: boolean;
  isDoughnut?: boolean;
  view?: number[];
  results: SelectionsObj[];
  scheme?: unknown;
  animations?: boolean;
  gradient?: boolean;
  showXAxis?: boolean;
  showYAxis?: boolean;
  showLegend?: boolean;
  showXAxisLabel?: boolean;
  xAxisLabel?: string;
  showYAxisLabel?: boolean;
  yAxisLabel?: string;
  legendPosition?: string;
  showGridLines?: boolean;
  label?: string;
  tooltipDisabled?: boolean;
  centerImage?: string;
  extra?: SelectionsObj;
  specialClasses?: string;
  hideIncreaseRow?: boolean;
  hideIndustryComparisonRows?: boolean;
  dataNotAvailable?: boolean;
  allowYAxisTickFormatting?: any;
  roundEdges?: boolean;
}
export interface DashboardAlertOption {
  month?: string;
  content?: string;
  project?: string;
  projectName?: string;
}
export interface DashboardAlertOptions {
  title: string;
  alerts: DashboardAlertOption[];
}

export interface SupplementProductByState {
  cignaHealthSelected: boolean;
  loyalAmericanSelected: boolean;
  state: string;
}

enum ContentTypes {
  applicationZip = 'application/zip',
  applicationPdf = 'application/pdf',
}
export class Util {
  public static getPasswordContrains(): PasswordConstraint[] {
    return [
      {
        name: 'PASSWORD.RULE1',
        formKey: 'invalidMinMaxPassword',
      },
      {
        name: 'PASSWORD.RULE2',
        formKey: 'invalidAtleatOnePassword',
      },
      {
        name: 'PASSWORD.RULE3',
        formKey: 'invalidOneUpLower',
      },
      {
        name: 'PASSWORD.RULE4',
        formKey: 'invalidMaxTwoCharRepeat',
      },
      {
        name: 'PASSWORD.RULE5',
        formKey: 'invalidAcceptSymbols',
      },
      {
        name: 'PASSWORD.RULE6',
        formKey: 'invalidDisallowNameId',
      },
    ];
  }
  public static buildDownloadOptions(
    extraParams?: any,
    extraHeaders?: any,
    observe?: boolean,
  ): {
    headers: HttpHeaders;
    params: HttpParams;
    responseType: 'json' | undefined;
  } {
    let headers = new HttpHeaders({
      'Content-Type': 'application/zip;charset=UTF-8;application/json',
      Accept: ContentTypes.applicationZip,
    });
    if (extraHeaders !== undefined) {
      Object.keys(extraHeaders).forEach((key) => {
        headers = headers.append(key, extraHeaders[key]);
      });
    }
    let params = new HttpParams();
    if (extraParams !== undefined) {
      Object.keys(extraParams).forEach((key) => {
        params = params.append(key, extraParams[key]);
      });
    }
    const observeParam = observe ? { observe: 'response' as 'events' } : {};
    return {
      ...observeParam,
      headers,
      params,
      responseType: 'arraybuffer' as 'json' | 'json' | undefined,
    };
  }
  public static download(
    response: HttpResponse<ArrayBuffer>,
    docName: string,
    docType: string,
  ) {
    /* The edge condition is met when SPA requested docType = xls or pdf,however,
    the API has returned .zip due to large file size >10MB
    */
    if (
      response.headers.get('content-type') === ContentTypes.applicationZip ||
      docType === 'zip'
    ) {
      const blob = new Blob([response.body as BlobPart], {
        type: ContentTypes.applicationZip,
      });
      const link = window.document.createElement('a');
      let url = null;

      url = window.URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', `${docName}.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (docType === 'pdf') {
      const blob = new Blob([response.body as BlobPart], {
        type: ContentTypes.applicationPdf,
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    } else if (docType === 'xlsx' || docType === 'xls' || docType === 'csv') {
      const blob = new Blob([response.body as BlobPart], {
        type:
          docType === 'xls' || docType === 'csv'
            ? 'application/vnd.ms-excel'
            : 'uint8array',
      });
      const link = window.document.createElement('a');
      let url = null;
      url = window.URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', `${docName}.${docType}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  public static stringToArrayBuffer(str: string): ArrayBuffer {
    const encoder = new TextEncoder();
    return encoder.encode(str).buffer;
  }

  public static base64ToArrayBuffer(base64: string) {
    return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  }

  public static getGender(gender: string) {
    let gen = '';

    if (gender === 'M') {
      gen = 'Male';
    } else if (gender === 'F') {
      gen = 'Female';
    } else if (gender === 'N') {
      gen = 'Non Natural';
    } else if (gender === 'U') {
      gen = 'Unknown';
    } else {
      gen = '';
    }

    return gen;
  }
}
